/**
 * Shared timing constants for the tarefas module.
 *
 * MIN_LOADING_MS — minimum spinner duration (ms) for async save/submit
 * operations in modals. Prevents the spinner from flashing too briefly on
 * fast responses, which looks broken. 600ms is imperceptible to the user
 * but covers the visual feedback requirement (REQUIREMENTS §9.1).
 *
 * HIGHLIGHT_MS — duration (ms) of the post-drop "highlight + settle" pulse on a
 * just-moved row (List) / card (Kanban). After a successful move/reorder the
 * moved element flashes for this long, then the highlight auto-clears so no
 * residual style lingers (R2 effects-task — AC-R2.1/R2.2). 600ms draws the eye
 * to the new position without overstaying. The CSS `@keyframes` owns the
 * visual; this constant owns the cleanup `setTimeout`.
 */
export const MIN_LOADING_MS = 600

export const HIGHLIGHT_MS = 600

// Snack do lote quando ele carrega TAMBÉM o aviso de solicitações do WS: o
// default de 8s (`state/modules/feedback/actions.js`) não cobre os ~270
// caracteres do caso parcial, e o aviso sumiria antes de ser lido.
export const SNACK_LOTE_COM_AVISO_MS = 14000
